export default "__VITE_ASSET__Cdj1NIa$__"